import { type FeedResponse } from '@services/FeedService';
import { type User } from '@services/UsersService';

export const mergeFeedProfiles = (
  prev: FeedResponse[],
  incoming: FeedResponse[],
  sliceEnd: number,
) => {
  const prevUsers = prev.filter((item): item is User => 'id' in item);
  const prevIdsSet = new Set(prevUsers.map((item) => item.id));

  const newItems = incoming.filter(
    (item): item is FeedResponse =>
      'ad' in item || ('id' in item && !prevIdsSet.has(item.id)),
  );

  if (newItems.length === 0) {
    return prev;
  }

  const nextProfiles = [...prev, ...newItems].slice(0, sliceEnd);

  if (
    nextProfiles.length === prev.length &&
    nextProfiles.every((item, index) => item === prev[index])
  ) {
    return prev;
  }

  return nextProfiles;
};
